// extracted by mini-css-extract-plugin
module.exports = {"container":"_1410bfd27b--container--ePHxp","illustration":"_1410bfd27b--illustration--hjnja","content":"_1410bfd27b--content--lIsuN"};